import React from "react";
import styled from "styled-components";
import { SectionEyebrow, SectionTitle, SectionDescription } from "../common/Section";

const Section = styled.section`
  padding: 1rem 8vw 5rem;
  @media (max-width: 480px) { padding-left: 5vw; padding-right: 5vw; }
`;

const Header = styled.div`
  display: flex; align-items: end; justify-content: space-between; gap: 24px;
  margin-bottom: 28px;
  @media (max-width: 860px) { flex-direction: column; align-items: start; }
`;

const List = styled.div`
  display: grid;
  border-top: 1px solid var(--ink-10);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 120px minmax(0,.8fr) minmax(0,1.2fr);
  gap: 20px; padding: 24px 0;
  border-bottom: 1px solid var(--ink-08);
  align-items: start;
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 10px; }
`;

const Index = styled.span`font-size: 12px; color: var(--accent-2); letter-spacing: .18em; text-transform: uppercase;`;
const Title = styled.h3`font-size: 1.3rem; color: var(--ink);`;
const Text = styled.p`color: var(--muted); line-height: 1.8;`;

const capabilities = [
  { idx: "01", title: "Original compositions", text: "Custom records and music concepts developed for artists, campaigns, live properties, and globally resonant releases." },
  { idx: "02", title: "Publishing strategy", text: "Rights-minded planning around splits, registrations, administration, and revenue architecture that protects long-term catalog value." },
  { idx: "03", title: "Artist services", text: "Release structuring, creative positioning, partner coordination, and market-aware execution for artists ready to scale with intent." },
  { idx: "04", title: "Brand & sync partnerships", text: "Music-led collaborations for campaigns, sonic identity, and sync-forward opportunities that feel culturally credible instead of opportunistic." },
];

const HomeCapabilities: React.FC = () => (
  <Section>
    <Header>
      <div>
        <SectionEyebrow>Capabilities</SectionEyebrow>
        <SectionTitle>Creative, commercial, and publishing infrastructure.</SectionTitle>
      </div>
      <SectionDescription>
        Publishing, creative development, artist infrastructure, and brand
        partnerships — built to compound, not expire.
      </SectionDescription>
    </Header>
    <List>
      {capabilities.map((c) => (
        <Row key={c.idx}>
          <Index>{c.idx}</Index>
          <Title>{c.title}</Title>
          <Text>{c.text}</Text>
        </Row>
      ))}
    </List>
  </Section>
);

export default HomeCapabilities;
